import React from 'react';
import { Shield, Siren, DollarSign, Crosshair, Home, ChevronsRight } from 'lucide-react';
import { LOOP, LANES, BASE_CENTER, TEAMS, TEAM_COLOR, TEAM_ENTRY, tileType } from './rtbBoard';

const TYPE_STYLE = {
  safe: { bg: 'rgba(59,130,246,0.55)', icon: Shield, glow: '#60A5FA' },
  checkpoint: { bg: 'rgba(202,138,4,0.55)', icon: Siren, glow: '#FACC15' },
  territory: { bg: 'rgba(22,163,74,0.5)', icon: DollarSign, glow: '#4ADE80' },
  ambush: { bg: 'rgba(220,38,38,0.55)', icon: Crosshair, glow: '#F87171' },
};
const startOf = Object.fromEntries(Object.entries(TEAM_ENTRY).map(([t, i]) => [i, t]));

function Tile({ r, c, cell, bg, glow, Icon, testId, title, kind }) {
  return (
    <div
      data-testid={testId}
      data-kind={kind}
      title={title}
      className="absolute flex items-center justify-center"
      style={{
        left: c * cell + 2, top: r * cell + 2, width: cell - 4, height: cell - 4, borderRadius: cell * 0.12,
        background: bg, border: `1px solid ${glow || 'rgba(255,255,255,0.18)'}`,
        boxShadow: glow ? `0 0 ${cell * 0.35}px ${glow}88, inset 0 0 ${cell * 0.2}px ${glow}55` : 'inset 0 0 6px rgba(0,0,0,0.8)',
      }}
    >
      {Icon && <Icon size={cell * 0.5} color="#fff" strokeWidth={2.4} style={{ filter: `drop-shadow(0 0 4px ${glow})` }} />}
    </div>
  );
}

export function RtbTiles({ cell, layout }) {
  return (
    <>
      {LOOP.map(([r, c], i) => {
        const start = startOf[i];
        if (start) return <Tile key={i} r={r} c={c} cell={cell} bg={`${TEAM_COLOR[start]}AA`} glow={TEAM_COLOR[start]} Icon={ChevronsRight} testId={`rtb-tile-L${i}`} title={`${start.toUpperCase()} start · safe`} />;
        const kind = tileType(i, layout);
        const s = TYPE_STYLE[kind];
        return <Tile key={i} r={r} c={c} cell={cell} bg={s ? s.bg : 'rgba(12,12,16,0.82)'} glow={s?.glow} Icon={s?.icon} testId={`rtb-tile-L${i}`} title={kind} kind={kind} />;
      })}
      {TEAMS.map((t) => LANES[t].map(([r, c], k) => (
        <Tile key={`${t}${k}`} r={r} c={c} cell={cell} bg={k === 5 ? TEAM_COLOR[t] : `${TEAM_COLOR[t]}55`} glow={TEAM_COLOR[t]}
          Icon={k === 5 ? Home : null} testId={k === 5 ? `rtb-home-${t}` : `rtb-lane-${t}-${k}`} title={k === 5 ? `${t.toUpperCase()} HOME` : `${t} home lane`} />
      )))}
    </>
  );
}

export function RtbBases({ cell }) {
  return TEAMS.map((t) => {
    const [r, c] = BASE_CENTER[t];
    const col = TEAM_COLOR[t];
    const R = cell * 2.4;
    return (
      <div key={t} data-testid={`rtb-base-${t}`} className="absolute rounded-full"
        style={{
          left: (c + 0.5) * cell - R, top: (r + 0.5) * cell - R, width: R * 2, height: R * 2,
          border: `${cell * 0.12}px solid ${col}`, background: `radial-gradient(circle, ${col}33 0%, ${col}11 55%, rgba(0,0,0,0.55) 75%)`,
          boxShadow: `0 0 ${cell * 0.9}px ${col}, inset 0 0 ${cell * 0.8}px ${col}99`,
        }}>
        <div className="absolute inset-[18%] rounded-full" style={{ border: `2px dashed ${col}88` }} />
        <div className="absolute left-1/2 -translate-x-1/2 text-center whitespace-nowrap" style={{ bottom: cell * 0.15 }}>
          <div className="rtb-marker leading-none" style={{ color: col, fontSize: cell * 0.5, textShadow: `0 0 10px ${col}` }}>{t.toUpperCase()}</div>
          <div className="rtb-display tracking-[0.25em] text-white/90" style={{ fontSize: cell * 0.26 }}>START</div>
        </div>
      </div>
    );
  });
}
